import { render, staticRenderFns } from "./VasionButton.vue?vue&type=template&id=4b679f29&scoped=true&"
import script from "./VasionButton.vue?vue&type=script&lang=js&"
export * from "./VasionButton.vue?vue&type=script&lang=js&"
import style0 from "./VasionButton.vue?vue&type=style&index=0&id=4b679f29&prod&lang=scss&"
import style1 from "./VasionButton.vue?vue&type=style&index=1&id=4b679f29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b679f29",
  null
  
)

export default component.exports